<dsy-card render-level="outer" has-border="true" card-color="#fff">
  <div class="filters">
    @if (programsLoadingSignal() || organizationsLoadingSignal()) {
      <div class="filters__loading">
        <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
      </div>
    } @else {
      <div class="filters__fields">
        @if (isOrganizationView()) {
          <fdr-past-performance-ui-organization-filters-panel
            [organizationEntries]="organizationFilterEntries()"
            [sitesEntries]="sitesFilterEntriesSignal()"
            [hasSelectedOrganization]="!!localStore.organization()"
            [showSitesCounterTag]="showSitesCounterTag()"
            [dateResetToken]="dateResetToken()"
            (dateValidityChange)="orgDateRangeValid.set($event)"
          ></fdr-past-performance-ui-organization-filters-panel>
        } @else {
          <fdr-past-performance-ui-program-filters-panel
            [programEntries]="programFilterEntriesSignal()"
            [productEntries]="productFilterEntriesSignal()"
            [showProductFilter]="localStore.showProductFilter()"
            [showProductsCounterTag]="showProductsCounterTag()"
            [dateResetToken]="dateResetToken()"
            (dateValidityChange)="progDateRangeValid.set($event)"
          ></fdr-past-performance-ui-program-filters-panel>
        }
      </div>
    }
    <div class="filters__actions">
      <dsy-button class="filters__reset" variant="link" color="neutral" (click)="onReset()" [disabled]="resetButtonDisabledSignal()"> {{ 'PD.BUTTONS.RESET_FILTERS' | translate }} </dsy-button>
      <dsy-divider class="filters__divider" divider-orientation="vertical" divider-color="light-grey"></dsy-divider>
      <dsy-button
        class="filters__apply"
        variant="primary"
        density="wide"
        fill
        (click)="onApply()"
        [disabled]="applyButtonDisabledSignal()"
      >
        <p class="filters__apply-text">{{ 'PD.BUTTONS.APPLY' | translate }}</p>
      </dsy-button>
    </div>
  </div>
</dsy-card>
